<ng-container *ngFor="let kv of keyValueList">
  <ion-button
    [ngClass]="{
      'select-buttons__button--outline': outline,
      'select-buttons__button--outline-disabled':
        outline && disableZero(kv.value),
      'select-buttons__button--outline-active':
        (outline && multipleResultArray.includes(kv.value)) ||
        selectedValue === kv.value,
      'select-buttons__button--disabled': disableZero(kv.value),
      'select-buttons__button--white':
        whiteBackground && kv.value !== selectedValue
    }"
    class="select-buttons__button"
    [color]="buttonColor(kv.value)"
    (click)="disableZero(kv.value) ? null : changeSelected(kv)"
    [disabled]="disableDeselect && !multiple ? disable(kv.value) : 'false'"
  >
    <ion-icon
      class="select-buttons__default-icon"
      *ngIf="kv.ionicIcon"
      slot="start"
      [name]="kv.ionicIcon"
      [style.color]="kv.color"
    ></ion-icon>

    <ion-icon
      class="select-buttons__default-icon"
      *ngIf="icon"
      slot="start"
      [src]="'../../../../assets/icons/' + icon + '.svg'"
      [style.color]="kv.color"
    ></ion-icon>

    <ion-icon
      class="select-buttons__default-icon"
      *ngIf="kv.equipmentIcon"
      slot="start"
      [src]="'../../../../assets/icons/equipment/' + kv.equipmentIcon + '.svg'"
      [style.color]="kv.color"
    ></ion-icon>

    {{ kv.key }} {{ kv.icon }}
  </ion-button>
</ng-container>
